//
// Editor store
//
// Handles map editor state.
//

// ------------------------------------
// Editor modes
// ------------------------------------

export const ADD = 'ADD';
export const REMOVE = 'REMOVE';

// ------------------------------------
// Editor colors
// ------------------------------------

export const BLACK = '#341130';
export const RED = '#D90718';
export const PINK = '#F25790';
export const YELLOW = '#FFC71C';
export const GREEN = '#50DEA0';
export const BLUE = '#31C2FF';

// ------------------------------------
// Action definitions
// ------------------------------------

export const ENABLE_EDITOR  = 'EDITOR/ENABLE';
export const DISABLE_EDITOR = 'EDITOR/DISABLE';
export const SET_MODE       = 'EDITOR/SET_MODE';
export const SET_COLOR      = 'EDITOR/SET_COLOR';

// ------------------------------------
// Action creators
// ------------------------------------

export const enableEditor = () => ({
  type: ENABLE_EDITOR
});

export const disableEditor = () => ({
  type: DISABLE_EDITOR
});

export const setMode = mode => ({
  type: SET_MODE,
  mode
});

export const setColor = color => ({
  type: SET_COLOR,
  color
});

export const toggleEditor = () => (dispatch, getState) => {
  const { editor } = getState();

  editor.enabled
    ? dispatch(disableEditor())
    : dispatch(enableEditor());
};

// ------------------------------------
// Initial state
// ------------------------------------

const initialState = {
  enabled: false,
  mode: ADD,
  color: BLACK
};

// ------------------------------------
// Reducer
// ------------------------------------

export default (state = initialState, action) => {
  switch (action.type) {
    case ENABLE_EDITOR:
      return {
        ...state,
        enabled: true
      };

    case DISABLE_EDITOR:
      return {
        ...state,
        enabled: false
      };

    case SET_MODE:
      return {
        ...state,
        mode: action.mode
      };

    case SET_COLOR:
      return {
        ...state,
        color: action.color
      };

    default:
      return state
  }
};



// WEBPACK FOOTER //
// ./src/store/modules/editor.js